import { render } from "./indexnineblog.vue?vue&type=template&id=16d92880"
import script from "./indexnineblog.vue?vue&type=script&lang=js"
export * from "./indexnineblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__